import { Theme } from '@mui/material';
import MuiSelect from '../../../../components/accordion/them.config';
import { MuiAlert } from '../../../../components/alerts/them.config';
import MuiBadges from '../../../../components/badge/theme.config';
import { MuiBreadcrumbs } from '../../../../components/breadCrumbs/theme.config';
import { MuiButton } from '../../../../components/buttons/theme.config';
import MuiCard from '../../../../components/card/theme.config';
import MuiCheckbox from '../../../../components/checkbox/theme.config';
import { MuiChip } from '../../../../components/chip/theme.config';
import MuiDrawer from '../../../../components/drawer/theme.config';
import MuiMenu from '../../../../components/dropDownButton/theme.config';
import { MuiUploadField } from '../../../../components/fileUploader/theme.config';
import MuiButtonGroup from '../../../../components/groupButton/theme.config';
import MuiDialog from '../../../../components/modal/theme.config';
import MuiProgress from '../../../../components/progress/theme.config';
import MuiRadio from '../../../../components/radio/theme.config';
import MuiAccordion from '../../../../components/select/theme.config';
import MuiSwitch from '../../../../components/switch/theme.config';
import { MuiTablePagination } from '../../../../components/table/theme.config';
import MuiInput from '../../../../components/textField/theme.config';
import { MuiTypography } from '../../../../components/typography/theme.config';
import type { Skin } from '../../types';
import MuiTabs from './../../../../components/tabs/theme.config';
import MuiTooltip from './../../../../components/tooltip/theme.config';
import avatar from './avatar';
import backdrop from './backdrop';
import fab from './fab';
import formControlLabel from './form-control-label';
import list from './list';
import pagination from './pagination';
import paper from './paper';
import popover from './popover';
import progress from './progress';
import Rating from './rating';
import Select from './select';
import slider from './slider';
import snackbar from './snackbar';
import switchOverrides from './switch';
import tablePagination from './table-pagination';
import timeline from './timeline';

const overrides = (skin: Skin) => {
  return {
    ...MuiAccordion(skin),
    ...MuiAlert,
    ...MuiSelect(skin),
    ...avatar,
    ...backdrop,
    ...MuiBadges,
    ...MuiBreadcrumbs,
    ...MuiButton,
    ...MuiButtonGroup,
    // ...buttonGroup,
    ...MuiCard(skin),
    ...MuiCheckbox,
    ...MuiChip,
    ...MuiUploadField,
    ...MuiDialog(skin),
    ...MuiDrawer(skin),
    ...fab,
    ...formControlLabel,
    // ...iconButton,
    ...MuiInput,
    ...list,
    ...MuiMenu(skin),
    ...pagination,
    ...paper,
    ...popover(skin),
    ...progress,
    ...MuiRadio,
    ...MuiProgress,
    ...Rating,
    ...Select,
    ...slider,
    ...snackbar(skin),
    ...MuiSwitch,
    ...tablePagination,
    ...switchOverrides,
    ...MuiTablePagination,
    ...MuiTabs,
    ...timeline,
    ...MuiTooltip,
    // ...typography,
    ...MuiTypography,
  } as Theme;
};

export default overrides;
